import FormValue from "./FormValue";

export default class DateValue extends FormValue {

  constructor(value){
    super(value===null?null:new Date(value));
  }

  set value(v){
    super.value = v;
    if(this._original && this._original.getTime){
      this.modified = this._original.getTime() !== v.getTime();
    }
  }

  get value(){
    return super.value;
  }
}


// WEBPACK FOOTER //
// ./src/Editor/DateValue.js